import { PipeTransform } from '@angular/core';
var RequestIssuePipe = /** @class */ (function () {
    function RequestIssuePipe() {
    }
    RequestIssuePipe.prototype.transform = function (value, year) {
        if (value == null) {
            return '';
        }
        if (!year) {
            return '' + value;
        }
        var valuestr = value < 1000 ? ('000' + value).slice(-3) : '' + value;
        return "" + year.substr(2, 2) + year.substr(6, 2) + "-" + valuestr;
    };
    return RequestIssuePipe;
}());
export { RequestIssuePipe };
